import type {
  APIColumnInputDataSourceConfig,
  ColumnInputDataSource,
  CreateTableInput,
  RelationColumnInputDataSourceConfig,
} from "../domain/table";
import type { APIColumnDataSource } from "./table.formatter";

export interface TableColumnTempInput {
  label: string;
  name: string;
  type: string;
  length?: number;
  required: boolean;
  unique: boolean;
  default?: string | number | boolean;
  nullable: boolean;
  dataSource?: APIColumnDataSource;
}

export function transformToCreateTableInput(input: {
  label: string;
  name: string;
  description?: string;
  columns: TableColumnTempInput[];
}): CreateTableInput {
  return {
    label: input.label,
    name: input.name,
    description: input.description || null,
    schema: input.columns.map((col) => ({
      label: col.label,
      name: col.name,
      type: col.type,
      required: col.required,
      unique: col.unique,
      length: col.length || null,
      default: col.default || null,
      data_source: col.dataSource ? getCreateTableInputDataSource(col.dataSource) : null,
    })),
  };
}

function getCreateTableInputDataSource(input: APIColumnDataSource): ColumnInputDataSource {
  let config: RelationColumnInputDataSourceConfig | APIColumnInputDataSourceConfig | undefined;
  if (input.config) {
    if ("url" in input.config) {
      const url = `${input.config.url}${input.config.queryParams ? `?${getQueryParams(input.config.queryParams)}` : ""}`;
      const apiConfig: APIColumnInputDataSourceConfig = {
        api_url: url,
        http_method: input.config.method,
        auth_type: input.config.authType,
        auth_token: input.config.authToken || null,
        headers: input.config.headers || null,
        target_fields: input.config.targetFields,
      };
      config = apiConfig;
    } else {
      const relationConfig: RelationColumnInputDataSourceConfig = {
        relation_table: input.config.relationTable,
        relation_table_column: input.config.relationTableColumn,
      };
      config = relationConfig;
    }
  }
  return {
    config: config ?? null,
    data: input.data ?? null,
    type: input.type,
  };
}

function getQueryParams(params: string[]): string {
  if (params.length === 0) return "";
  const queryParams = params.map((param) => {
    const [key, value] = param.split("=");
    return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  });
  return queryParams.join("&");
}
